import React, {memo} from 'react';
import PropTypes from 'prop-types';
import Typography from "../Typography";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import {useNavigate} from "react-router-dom";

const BreadcrumbItem = ({ item, isLast, truncateLast, onNavigate }) => {
    const isLink = Boolean(item.url);

    return (
        <div
            className={`uppercase ${
                truncateLast && isLast ? 'min-w-0 flex-1 overflow-hidden' : 'inline-block'
            } ${truncateLast && !isLast ? 'shrink-0' : ''}`}
        >
            <Typography
                variant={"subtitle2"}
                className={`${isLast && "text-headings"} ${truncateLast && isLast ? 'truncate' : ''}`}
            >
                <span
                    title={isLast ? item.fullTitle || item.title : undefined}
                    onClick={() => isLink && onNavigate(item)}
                    className={`${isLink ? "cursor-pointer" : ""} ${
                        truncateLast && isLast ? 'block truncate' : ''
                    }`}
                >
                    {item.title}
                </span>
                {!isLast && (
                    <ArrowForwardIosIcon className={"!h-[14px] !w-[14px] inline-block align-middle"} />
                )}
            </Typography>
        </div>
    );
};

const Breadcrumbs = ({data, className, truncateLast = false}) => {
    let navigate = useNavigate()

    const handleNavigate = (item) => {
        navigate(item.url, item.state ? { state: item.state } : {});
    };

    if (truncateLast) {
        return (
            <div className={`mb-4 flex min-w-0 items-center ${className || ''}`}>
                {data?.map((item, index) => (
                    <BreadcrumbItem
                        key={index}
                        item={item}
                        isLast={index === data.length - 1}
                        truncateLast
                        onNavigate={handleNavigate}
                    />
                ))}
            </div>
        );
    }

    return (
        <div className={`mb-4 ${className}`}>
            {
                data?.map((item, index) => {
                    return (
                        <div key={index} className={"inline-block uppercase"}>
                            <Typography variant={"subtitle2"}
                                        className={`${index === data?.length - 1 && "text-headings"}`}>
                                <span onClick={() => item.url && navigate(item.url, item.state ? { state: item.state } : {})}
                                      className={`${item.url && "cursor-pointer"}`}>{item.title}</span> {
                                ![data?.length - 1].includes(index) &&
                                <ArrowForwardIosIcon className={"!h-[14px] !w-[14px]"}/>} </Typography>
                        </div>
                    )
                })
            }
        </div>
    );
};

Breadcrumbs.propTypes = {
    data: PropTypes.array,
    truncateLast: PropTypes.bool,
};

export default memo(Breadcrumbs);
